export const BASE_DOCX_TEMPLATES = {
  LANDSCAPE: 'Landscape',
  PORTRAIT: 'Portrait',
};
